import * as React from "react";
// Local components
import EditInfo from "./components/EditInfo";
import UserInfo from "./components/UserInfo";
// Shared componenst
import Maybe from "components/Maybe";
// Utilities and hooks
import { get } from "lodash";
import UserStore from "state/user";
import { observer, inject } from "mobx-react";

interface IProps {
	user?: UserStore;
}

const Profile: React.FC<IProps> = props => {
	const user = props.user ? props.user.getUser : {};
	const [editable, setEditable] = React.useState(false);

	React.useEffect(() => {
		if (get(user, ["profile", "profileStatus"]) === "NOT_COMPLETED") {
			setEditable(true);
		}
	}, [user]);

	function handleSubmitUserInfo() {
		setEditable(true);
	}

	function handleSubmitEditInfo() {
		setEditable(false);
	}

	return (
		<>
			<Maybe condition={!editable}>
				<UserInfo onSubmit={handleSubmitUserInfo} />
			</Maybe>
			<Maybe condition={editable}>
				<EditInfo onSubmit={handleSubmitEditInfo} />
			</Maybe>
		</>
	);
};
export default inject("user")(observer(Profile));
